(function () {

  'use strict';

  angular.module('PrinterIssueList')

    .constant('SORT_ISSUE_PRINTERS', {
      SIGN_ID: 'Id'
    })

    .controller('PrinterIssueListController', function (
      $rootScope, $scope, $filter, PrinterListService, $location, $ngBootbox, toastr, PrinterListPOSTPaging,
      SORT_ISSUE_PRINTERS, EventServiceEvents, EventHandlerService, currentTenant, $timeout, enums) {

      $scope.orderByText = 'Id';
      $scope.searchInputFieldHolderFocusKey = 'searchInputFieldHolderFocusKey';
      $scope.checkAllCheckboxes = false;
      $scope.selectedPrinterCount = 0;
      $scope.searchInputPlaceholderText = 'Search';
      $scope.printerListPaging = new PrinterListPOSTPaging();
      $scope.printerListPaging.pagingCriteria.networkTypeFilter = 'NONE';
      $scope.printerContainer = null;
      $scope.noDataMessage = 'NoPrintersMatchedTheSearchCriteria';
      $scope.requestType = 'GET';
      $scope.eventHandlerService = EventHandlerService;
      $scope.me = null;
      $scope.helpCaption = 'HelpPrinterIssueList';

      $scope.getPrinterListPaged = function () {
        $scope.printerListPaging.pagingCriteria.networks = $scope.me.permissions.TENANT_ADMIN ? null : $scope.me.networks;
        $scope.printerListPaging.pagingCriteria.underCreation = true;
        PrinterListService.getPrinterListPaged($scope.printerListPaging)
          .then(function (printerContainer) {
            $scope.printerContainer = printerContainer;
          })
          .catch(function () {
          });
      };

      $scope.getPreviousPage = function () {
        if ($scope.printerListPaging.pagingCriteria.page > 0) {
          $scope.printerListPaging.pagingCriteria.page--;
          $scope.getPrinterListPaged();
        }
      };

      $scope.getNextPage = function () {
        if ($scope.printerListPaging.pagingCriteria.page + 1 < $scope.printerContainer.page.totalPages) {
          $scope.printerListPaging.pagingCriteria.page++;
          $scope.getPrinterListPaged();
        }
      };

      $scope.changeOrderByValue = function (column) {
        $scope.reverse = !$scope.reverse;
        $scope.printerListPaging.pagingCriteria.direction = $scope.reverse ? 'DESC' : 'ASC';
        $scope.printerListPaging.pagingCriteria.sort = column;
        $scope.orderByText = SORT_ISSUE_PRINTERS[column];
        $scope.getPrinterListPaged();
      };

      $scope.deletePrinter = function (printer) {
        $ngBootbox.confirm($filter('stringular')($filter('translate')('DeletePrinter'), printer.info.signId))
          .then(function () {
            PrinterListService.deletePrinter(printer)
              .then(function () {
                toastr.success($filter('stringular')($filter('translate')('PrinterDeleted'), printer.info.signId));
              })
              .catch(function () {
              });
          })
          .catch(function () {
          });
      };

      $scope.deleteSelectedPrinters = function () {
        if ($scope.printerContainer.list.length > 0) {
          const searchCriteriaObject = {
            options: {
              isSelected: true
            }
          };
          const selectedPrinters = $scope.printerContainer.list.findAllElements(searchCriteriaObject);
          if (selectedPrinters.length > 0) {
            let message = '';
            if (selectedPrinters.length === 1) {
              message = $filter('stringular')($filter('translate')('DeletePrinter'), selectedPrinters[0].info.signId);
            } else {
              message = $filter('stringular')($filter('translate')('DeletePrinters'), selectedPrinters.length);
            }
            $ngBootbox.confirm(message)
              .then(function () {
                PrinterListService.deleteSelectedPrinters(selectedPrinters, function () {
                  let message = '';
                  if (selectedPrinters.length === 1) {
                    message = $filter('stringular')($filter('translate')('PrinterDeleted'), selectedPrinters[0].info.signId);
                  } else {
                    message = $filter('stringular')($filter('translate')('PrintersDeleted'), selectedPrinters.length);
                  }
                  toastr.success(message);
                });
              })
              .catch(function () {
              });
          } else {
            toastr.error($filter('translate')('SelectPrinterNone'));
          }
        }
      };

      $scope.diagnosePrinterIssue = function (printer) {
        if ($scope.printerContainer.list.length > 0) {
          const selectedPrinters = $scope.printerContainer.list.findAllElements({ options: { isSelected: true } });
          if (printer || selectedPrinters.length === 1) {
            if (!printer) {
              printer = selectedPrinters[0];
            }
            if (!printer.isUnderCreation) {
              $location.path(`printerIssue/${printer.customProperties.id}`);
            } else {
              toastr.error($filter('translate')('DiagnoseNotNow'));
            }
          }
        }
      };

      $scope.selectAllPrinters = function () {
        angular.forEach($scope.printerContainer.list, function (printer) {
          printer.options.isSelected = $scope.checkAllCheckboxes;
        });
      };

      $scope.copyIpAddress = function (ipAddress) {
        if (!ipAddress.startsWith('\\\\')) {
          ipAddress = ipAddress.split(' ')[0];
        }
        const input = document.createElement('input');
        input.setAttribute('value', ipAddress);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        toastr.success($filter('translate')('CopyToClipboard'));
      };

      $scope.openContext = function (event, context, menuOption) {
        $scope.closeAllMenues();
        $timeout(function () {
          $scope.selectedContextMenuItem = menuOption;
          $scope.contextContentPosition = { left: event.clientX, top: event.clientY };
          $scope.contextPosition = { left: event.clientX, top: event.clientY };
          $scope.contextContent = context;
          $scope.context = context;
          $scope.auxiliaries = {
            tenant: currentTenant,
            enums,
            network: null,
            me: $scope.me
          };
        }, 50);
      };

      $scope.closeAllMenues = function () {
        $scope.menuContent = null;
        $scope.menuSpecs = null;
        $scope.selectedContextMenuItem = null;
        $scope.contextContentPosition = null;
        $scope.contextPosition = null;
        $scope.contextContent = null;
        $scope.context = null;
        $scope.auxiliaries = null;
      };

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          $scope.getPrinterListPaged();
        }
      });

      $scope.$watch(function () {
        return $scope.printerContainer?.list;
      }, function () {
        if ($scope.printerContainer?.list) {
          $scope.selectedPrinterCount = $scope.printerContainer.list.findAllElements({ options: { isSelected: true } }).length;
          if ($scope.selectedPrinterCount) {
            $scope.checkAllCheckboxes = $scope.selectedPrinterCount === $scope.printerContainer.list.length;
          } else {
            $scope.checkAllCheckboxes = false;
          }
        }
      }, true);

      (function () {
        $scope.eventHandlerService.deRegisterListeners();
        registerEventHandlers();
      })();

      function registerEventHandlers() {

        // This event is received when a printer has been finalized and is not unregistered anymore.
        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_ADDED, function (event, data) {
          // Cannot check if the printer is in the list, because a new ID is assigned after finalization.
          $scope.getPrinterListPaged();
        });

        // This event is received when a printer has been removed.
        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_REMOVED, function (event, data) {
          if (isPrinterInList(data.printer)) {
            $scope.getPrinterListPaged();
          }
        });

        // Commented out because this event seems irrelevant.
        // $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function (event, data) {
        //   console.log('Printer Update event received:', data.printer);
        //   $scope.getPrinterListPaged();
        // });

        // Commented out because this event seems irrelevant.
        // $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_STATUS_UPDATE, function (event, data) {
        //   $scope.getPrinterListPaged();
        // });

        // This event is received when a printer has been created and is still unregistered.
        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_CREATION_UPDATE, function (event, data) {
          // This is the first creation state after the printer has been created.
          if (data.creationState === 'RETRIEVING_MODEL') {
            $scope.getPrinterListPaged();
          }
        });

        // Commented out because this event seems irrelevant.
        // $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.QUEUE_DRIVER_CONFIG_CHANGED, function (event, data) {
        //   $scope.getPrinterListPaged();
        // });

        // Commented out because $scope.getQueueListPaged() does not exist.
        // $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_GROUPS_UPDATED, function (event, data) {
        //   if (!data.partOfBatch) {
        //     $scope.getQueueListPaged();
        //   }
        // });

      }

      function isPrinterInList(printerSelfHref) {
        return $scope.printerContainer?.list?.some(printer => printer.info._links.self.href === printerSelfHref);
      }

    });
})();
